import { merge } from 'lodash-es';
import { fullNameSchema as platformFullNameSchema } from 'platform/forms-system/src/js/web-component-patterns';

export const fullNameSchema = definition =>
  merge({}, platformFullNameSchema, definition);

export const emptySchema = {
  type: 'object',
  properties: {},
};
